export default __webpack_public_path__ + "static/media/668.045bfb3d.png";